import CompetitorsSoldOutAlertExecutionNotification
	from '@app/model/alert/CompetitorsSoldOutAlertExecutionNotification';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import React from 'react';
import Utilities from '@util/Utilities';
import Tag from '@app/component/tag/Tag';


const CompetitorsSoldOutNotificationRowFragment: React.FunctionComponent<{
	companyHotel: CompanyHotel,
	notification: CompetitorsSoldOutAlertExecutionNotification
}> = ({ companyHotel, notification }) => {

	const findHotelName = (hotelId: number) => {
		return companyHotel.allHotels?.find(hotel => hotel.id === hotelId)?.name ?? `Hotel #${hotelId}`;
	};

	const isNewSoldOutHotel = (hotelId: number) => {
		return notification.newSoldOutHotelIds.includes(hotelId);
	};

	return <tr>
		<td className="whitespace-nowrap py-4 pl-0 pr-3 text-sm font-semibold text-gray-950">
			{Utilities.formatDateString(notification.statDate, 'ddd DD MMM', false)}
		</td>
		<td className="whitespace-nowrap px-2 py-4 text-sm">
			<span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-semibold text-red-700 ring-1 ring-inset ring-red-600/10">{notification.soldOutHotelIds.length}</span>
		</td>
		<td className="whitespace-normal px-2 py-4 text-sm text-gray-600">
			<div className="flex flex-wrap gap-2">
				{notification.soldOutHotelIds.map(hotelId => <Tag key={hotelId}
					state={isNewSoldOutHotel(hotelId) ? "blue" : "gray"}>
					{findHotelName(hotelId)}
				</Tag>)}
			</div>
		</td>
		<td className="whitespace-nowrap py-4 pl-3 pr-0 text-right text-sm font-semibold text-red-600">
			SO
		</td>
	</tr>;
};

export default CompetitorsSoldOutNotificationRowFragment;
